import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import CONFIG from 'config';

export interface PromptsState {
  totalCount: number;
  skip: number;
  limit: number;
  searchTerm: string | null;
}

const initialState: PromptsState = {
  totalCount: 0,
  skip: 0,
  limit: CONFIG.PROMPTS_LIMIT,
  searchTerm: null,
};

const slice = createSlice({
  name: 'prompts',
  initialState,
  reducers: {
    updateSearchTerm(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload;
    },
    updateTotalCount(state, action: PayloadAction<number>) {
      state.totalCount = action.payload;
    },
    updateSkip(state, action: PayloadAction<number>) {
      state.skip = action.payload;
    },
  },
});

export const promptActions = slice.actions;

export default slice.reducer;

